import { Breadcrumb, Button, Card, Empty, Modal } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import moment from "moment";
import { amountFormat } from "../../services/common.service";
import PendingAuthService from "../../services/approvals.service";
import PaymentService from "../../services/payments.service";
import { useTranslation } from "react-i18next";
import { ReactComponent as TitleIcon } from "../../assests/images/transfer.svg";
import { ReactComponent as DownloadIcon } from "../../assests/icons/download.svg";
import GepgHistoryGrid from "../../components/gepg-history-grid";
import GepgHistoryList from "../../components/gepg-history-list";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";

export default function GovernmentPaymentHistory() {
  const navigate = useNavigate();
  const [dataSource, setDataSource] = useState([]);
  const [size, setSize] = useState(20);
  const [hasMoreRecords, setHasMoreRecords] = useState(false);
  const [visible, setVisible] = useState(false);
  const [details, setDetails] = useState({});
  const { t } = useTranslation();
  const [showGridAccount, setShowGridAccount] = useState("GRID");

  useEffect(() => {
    if (window.innerWidth < 900) {
      setShowGridAccount("LIST");
    }
  }, [window.innerWidth]);

  useEffect(() => {
    governmentPaymentHistory(0, 20);
  }, []);

  const governmentPaymentHistory = useCallback(async (page, size) => {
    try {
      const response = await PaymentService.gepg_History({
        page: page,
        size: size,
      });
      if (response.status === 200) {
        setDataSource(response.data["data"]);
        setHasMoreRecords(
          response.data["pagination"]["totalElements"] !==
            response.data["data"]?.length
        );
      }
    } catch (error) {}
  }, []);

  const fetchMoreHistory = useCallback(() => {
    try {
      setSize(size + 20);
      governmentPaymentHistory(0, size + 20, "");
    } catch (error) {}
  }, [size]);

  const handleDownload = useCallback(async (selected) => {
    try {
      const reqParams = {
        txnId: selected?.billId,
      };
      setVisible(false);
      await PendingAuthService.downloadGepgPaymentReceipts(reqParams);
    } catch (err) {}
  }, []);

  return (
    <>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/government-payment")}>
              {t("pages.gepeg.government_payment", {
                defaultValue: "Government Payment",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("pages.gepeg.government_payment_history", {
                defaultValue: "Government Payment History",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("pages.gepeg.government_payment_history", {
                defaultValue: "Government Payment History",
              })}
            </h3>
          </div>
        </div>
      </Card>

      <Card className="application-card" style={{ padding: "5px" }}>
        {showGridAccount === "GRID" && (
          <GepgHistoryGrid
            dataSource={dataSource}
            handleDownload={handleDownload}
            setDetails={setDetails}
            setVisible={setVisible}
            hasMoreRecords={hasMoreRecords}
            fetchMoreHistory={fetchMoreHistory}
          />
        )}
        {showGridAccount === "LIST" && (
          <GepgHistoryList
            dataSource={dataSource}
            handleDownload={handleDownload}
            setDetails={setDetails}
            setVisible={setVisible}
            hasMoreRecords={hasMoreRecords}
            fetchMoreHistory={fetchMoreHistory}
          />
        )}
      </Card>

      <Modal
        title={""}
        open={visible}
        footer={null}
        width={750}
        closable={false}
        maskClosable={false}
        mask={true}
        centered
      >
        <h3 className="primary-title">
          {t("pages.gepeg.gepg_detail", {
            defaultValue: "GePG Details",
          })}
        </h3>

        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {t("pages.gepeg.bill_control_no", {
                    defaultValue: "Bill Control No",
                  })}
                </span>
                <p className="value-receipt">{details?.controlNum}</p>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {t("pages.gepeg.entry_count", {
                    defaultValue: "Entry Count",
                  })}
                </span>
                <p className="value-receipt">{details?.entryCount}</p>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {" "}
                  {t("pages.gepeg.pay_type", { defaultValue: "Pay Type" })}
                </span>
                <p className="value-receipt">{details?.payType}</p>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {" "}
                  {t("pages.gepeg.bill_id", { defaultValue: "Bill ID" })}{" "}
                </span>
                <p className="value-receipt">{details?.billId}</p>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {t("pages.gepeg.sts_description", {
                    defaultValue: "STS Description",
                  })}
                </span>
                <p className="value-receipt">{details?.stsDesc}</p>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <div className="lbl-receipt">
                  {t("pages.gepeg.bill_currency", {
                    defaultValue: "Bill Currency",
                  })}
                </div>
                <p className="value-receipt">{details?.billCcy}</p>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {t("pages.gepeg.source_account", {
                    defaultValue: "Source Account",
                  })}
                </span>
                <p className="value-receipt">{details?.debitAccount}</p>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {t("pages.gepeg.source_currency", {
                    defaultValue: "Source Currency",
                  })}
                </span>
                <p className="value-receipt">{details?.debitCcy}</p>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <div className="lbl-receipt">
                  {" "}
                  {t("pages.gepeg.bill_amount", {
                    defaultValue: "Bill Amount",
                  })}{" "}
                </div>
                <p className="value-receipt">
                  {amountFormat(details?.billAmount, details?.billCcy)}
                </p>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <div className="lbl-receipt">
                  {" "}
                  {t("pages.gepeg.paid_amount", {
                    defaultValue: "Paid Amount",
                  })}{" "}
                </div>
                <p className="value-receipt">
                  {amountFormat(details?.paidAmount, details?.billCcy)}
                </p>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <div className="lbl-receipt">
                  {t("common.payment_date", { defaultValue: "Payment Date" })}{" "}
                </div>
                <p className="value-receipt">
                  {(details?.initDate &&
                    moment(details?.initDate).format("DD.MM.YYYY hh:mm A")) ||
                    "-"}
                </p>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <div className="lbl-receipt">
                  {t("pages.gepeg.ref_no", {
                    defaultValue: "Reference Number",
                  })}
                </div>
                <p className="value-receipt">{details?.referenceNo || "-"}</p>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <div className="lbl-receipt">
                  {t("common.payment_status", {
                    defaultValue: "Payment Status",
                  })}{" "}
                </div>
                <p className="value-receipt">{details?.status || "-"}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end mt-5">
          <Button
            onClick={() => setVisible(false)}
            className="secondary-btn"
            type="default"
            size="large"
          >
            {t("buttons.close_btn", { defaultValue: "Close" })}
          </Button>
          {/* <Button
            size="large"
            onClick={() => handleDownload(details)}
            type="primary"
            className="primary-btn mx-3"
          >
             {t("buttons.download_btn", { defaultValue: "Download" })}
          </Button> */}
        </div>
      </Modal>
    </>
  );
}
